import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-500">为什么选择91影视看片下载</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5 max-w-6xl mx-auto">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl p-5 md:p-6 text-center hover:scale-[1.02] transition-transform duration-200"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary-200 transition-colors duration-200">
                <i className={`${item.icon} text-primary-600 text-xl md:text-2xl w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}